import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import ExpertPpvBlogJsx from './expertPpvBlog.jsx'

export default class ExpertPpvBlog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            isProcessing: false,
            profileData:null,
            blogData: null
        }
    }

    componentDidMount = () => {
        this.getBlogData();
        if(this.props.location?.state?.data){
            const {data,pagePath} = this.props.location?.state;
            pagePath && this.setState({fromPage:pagePath,profileData:data});       
           
            // data && this.setState({profileData:data, legalName:(data.legalName).replace(/\//g, "")},()=> this.getOfferData());
          }
    }

    getBlogData = () => {
        const token = JSON.parse(localStorage.getItem('token'));

   
        this.setState({ isProcessing: true })

        axios.get(`${baseURL}/articles?page=${this.state.page}&limit=999&expertid=${ this.props.location.state.expertIDSlug}`,
            {
                headers: { 'x-access-token': token }
            }).then(res => {
                this.setState({ blogData: res.data.data, isProcessing: false });
            }).catch(err=>{
                this.setState({isProcessing: false})
              })
    }

    onPaginationButtonClick = (page) => {
        window.scrollTo(0, 0);
        this.setState({ page: page })
    }

    render() {
        return (
            <div>
                <ExpertPpvBlogJsx
                    blogData={this.state.blogData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    page={this.state.page}
                    profileData={this.state.profileData}
                    
                />
                {this.state.isProcessing && <Loader />}
            </div>
        )
    }
}